import * as React from 'react';

export const  Figma =()=> (
<svg version="1.1" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
 <g>
  <path id="a" style={{ fill: ':#0acf83'}} d="m26 66c6 0 10-4 10-10v-10h-10c-6 0-10 4-10 10s4 10 10 10z"/>
  <path id="b" style={{ fill: '#a259ff'}} d="m16 36c0-6 4-10 10-10h10v20h-10c-6 0-10-4-10-10z"/>
  <path id="c" style={{ fill: '#f24e1e'}} d="m16 16c0-6 4-10 10-10h10v20h-10c-6 0-10-4-10-10z"/>
  <path id="d" style={{ fill: '#ff7262'}} d="m36 6h10c6 0 10 4 10 10s-4 10-10 10h-10z"/>
  <path id="e" style={{ fill: '#1abcfe'}} d="m56 36c0 6-4 10-10 10s-10-4-10-10 4-10 10-10 10 4 10 10z"/>
 </g>
</svg>
)
